<script setup>
import {computed, onMounted, watch} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  voiceTheme: {
    type: Object,
    required: true,
  }
});

// 締め切り時刻を Date オブジェクトに変換
const endAt = computed(() => props.voiceTheme.value && 'end_at' in props.voiceTheme.value ? new Date(props.voiceTheme.value.end_at * 1000) : null);
const endAtString = computed(() => endAt.value ? endAt.value.getFullYear()+'.'+(endAt.value.getMonth() + 1)+'.'+endAt.value.getDate()+' '+endAt.value.getHours()+':'+endAt.value.getMinutes() : '');
const endAtAttribute = computed(() => endAt.value ? String(endAt.value.getFullYear()).padStart(4, '0')+'-'+String(endAt.value.getMonth() + 1).padStart(2, '0')+'-'+String(endAt.value.getDate()).padStart(2, '0')+'T'+String(endAt.value.getHours()).padStart(2, '0')+':'+String(endAt.value.getMinutes()).padStart(2, '0') : '');
</script>

<template>
  <div class="lyPd8 lyPb24 lyTbPd16 pBackColorWhite">
    <p class="lyMb8 pFont14 pFontMedium pTbFont16 pTbFontBold">{{voiceTheme.value.title}}</p>
    <dl class="lyMb8">
      <div class="lyHorizontal lyMb4">
        <dt class="lyMr8 pFont12 pFontMedium">回答締切</dt>
        <dd class="pFont12 pFontMedium"><time
          :datetime="endAtAttribute"
          class="lyBlock"
        >{{endAtString}}</time></dd>
      </div>
      <div class="lyHorizontal lyMb4">
        <dt class="lyMr8 pFont12 pFontMedium">回答方法</dt>
        <dd
          v-if="Number(voiceTheme.value.question_type) === 2"
          class="pFont12 pFontMedium"
        >選択式</dd>
        <dd
          v-if="Number(voiceTheme.value.question_type) === 3"
          class="pFont12 pFontMedium"
        >選択式・記述式</dd>
        <dd
          v-else
          class="pFont12 pFontMedium"
        >自由記述</dd>
      </div>
      <div
        v-if="voiceTheme.value.voice_gift"
        class="lyHorizontal"
      >
        <dt class="lyMr8 pFont12 pFontMedium">プレゼント方法</dt>
        <dd class="pFont12 pFontMedium">{{Number(voiceTheme.value.voice_gift.type) === 2 ? '配送' : 'メール'}}</dd>
      </div>
    </dl>
    <p class="pChip dComment mdNotBtn lyMb8">
      <span class="pFont14 pFontMedium">{{'voices' in voiceTheme.value && Array.isArray(voiceTheme.value.voices) ? new Intl.NumberFormat().format(voiceTheme.value.voices.length) : '-'}}</span>
    </p>
    <ul>
      <li
        v-if="Number(voiceTheme.value.add_point) > 0"
        class="lyPd4 lyInlineBlock pFont12 pFontMedium pBackColorGray4 pBorderRadius2px lyMb4"
      >ポイント&nbsp;{{voiceTheme.value.add_point}}P</li>
      <li
        v-if="voiceTheme.value.voice_gift"
        class="lyPd4 lyInlineBlock pFont12 pFontMedium pBackColorGray4 pBorderRadius2px"
      >{{voiceTheme.value.voice_gift.name}}&nbsp;{{voiceTheme.value.voice_gift_limit}}名</li>
    </ul>
  </div>
</template>
